module.exports = __webpack_public_path__ + "img/34_28.e82a773e.png";